import React from 'react';
import { Box } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

const CoreChip: React.FC = () => (
  <Box
    sx={{
      alignItems: 'center',
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'primary.tableBorder',
      borderRadius: 999,
      color: 'text.secondary',
      display: 'inline-flex',
      fontSize: 12,
      fontWeight: 600,
      gap: 0.5,
      height: 24,
      pl: 0.875,
      pr: 1.125,
    }}
  >
    <LockIcon sx={{ fontSize: 14 }} />
    {'Основний'}
  </Box>
);

export default CoreChip;
